/* eslint-disable max-len */
const initializeInquireNow = () => {
  if (!window.dataRegion) {
    console.warn('No region found on window.');
    return;
  }

  const dialog = document.getElementById('inquireNow');
  const body = document.querySelector('body');

  if (dialog) {
    // const form = dialog.querySelector('form');
    const close = dialog.querySelector('.close-btn');
    const inquireNowButtons = Array.from(document.querySelectorAll('[data-inquire]'));

    const clickOutSide = ({ target }) => {
      const rect = dialog.getBoundingClientRect();
      const isInDialog = (rect.top <= target.clientY && target.clientY <= rect.top + rect.height
          && rect.left <= target.clientX && target.clientX <= rect.left + rect.width);
      const isInInquireNowButton = inquireNowButtons.some((btn) => btn.contains(target));

      if (isInDialog === false && isInInquireNowButton === false) {
        dialog.close();
      }
    };
    const pressedEscape = ({ keyCode }) => {
      if (keyCode === 27) {
        dialog.close();
      }
    };

    const callDialog = () => {
      dialog.showModal();
      body.style.overflowY = 'hidden';
      close.addEventListener('click', closeDialog);
      document.addEventListener('click', clickOutSide);
      document.addEventListener('keyup', pressedEscape);
    };

    const closeDialog = () => {
      dialog.close();
    };

    const initializeButtons = (tried = 0) => {
      if (inquireNowButtons.length === 0 && tried < 6) {
        setTimeout(() => initializeButtons((tried + 1)), 500);
      } else {
        inquireNowButtons.forEach((btn) => {
          btn.addEventListener('click', callDialog);
        });
      }
    };

    dialog.addEventListener('close', () => {
      body.style.overflowY = 'auto';
      document.removeEventListener('click', clickOutSide);
      document.removeEventListener('click', pressedEscape);
    });

    initializeButtons();
  } else {
    console.warn('Inquire now dialog was not found on the DOM.');
  }
};

// Sometimes it takes time for dataRegion to be defined
// So I've created a recursive function to ensure we're not
// breaking on a race condition
const checkDataRegion = () => {
  if (window.dataRegion) {
    initializeInquireNow();
  } else {
    setTimeout(checkDataRegion, 100);
  }
};

checkDataRegion();
window.initializeInquireNow = initializeInquireNow;
